<fieldset class="rounded-md border border-solid border-gray-300 p-4">
  <legend class="inline-block px-2 text-sm font-medium">High Caries</legend>
  <form class="flex flex-col gap-2" [formGroup]="form()">
    <mat-form-field class="w-full" subscriptSizing="dynamic">
      <mat-label>Patient Criteria</mat-label>
      <mat-select formControlName="requestReason">
        @for (reason of requestReasons; track reason) {
          <mat-option [value]="reason">
            {{ requestReasonLabelMap[reason] }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    <div class="flex gap-2">
      <mat-checkbox formControlName="teethBeenFissureSealed" class="flex-1">
        Teeth previously fissure sealed?
      </mat-checkbox>
      <pt-iso-date-selector
        class="flex-1"
        formControlName="dateFissureSealed"
        placeholder="If so, when?"
      />
    </div>
    <mat-form-field class="flex-1" subscriptSizing="dynamic">
      <mat-label>If not, why not?</mat-label>
      <input matInput formControlName="notFissureSealedReason" />
    </mat-form-field>
    <div class="flex gap-2">
      <mat-checkbox formControlName="teethRestored" class="flex-1">
        Teeth previously restored?
      </mat-checkbox>
      <mat-checkbox formControlName="dentinalToothStructure" class="flex-1">
        Restorations involve dentinal tooth structure?
      </mat-checkbox>
    </div>
    <mat-form-field>
      <mat-label>Other comments</mat-label>
      <textarea matInput formControlName="otherComments" rows="1"></textarea>
    </mat-form-field>
  </form>
</fieldset>
